export default __webpack_public_path__ + "static/timberline-28-ORBITAL-SCRUBBER-education-46ed7a717f3323b4f20582b58ee0cbc6.jpg";